import React from 'react';
import TablaFiscales from '../components/fiscales/tablaFIscales';

function Fiscales() {
    return (
        <div className='col-sm-12 d-flex justify-content-center row p-0 m-0'>
                <TablaFiscales />
        </div>
    );
}

export default Fiscales;




// WEBPACK FOOTER //
// ./src/pages/fiscales.js